import { takeLatest, select, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './parts-constants';
import * as actions from './parts-actions';

export function* searchPart(action) {
  try {
    const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;
    const { searchValue, items, serviceCenterId } = action.payload;
    const request = searchValue ? {
      query: searchValue,
    } : {
      items,
    };
    const serviceCenterIdState = yield select(getServiceCenterId);
    const results = yield call(callApi, {
      // eslint-disable-next-line max-len
      endpoint: `refdata/search/material?serviceCenterId=${serviceCenterIdState || serviceCenterId}/materialNumbers`,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not search parts',
        retryAction: action,
      },
    });

    yield put(actions.searchPartSuccess(results));
  } catch (err) {
    yield put(actions.searchPartFailure(err));
  }
}

export function* addPart(action) {
  try {
    const { orderId, materials, callback } = action.payload;
    const request = {
      materials,
    };
    const results = yield call(callApi, {
      endpoint: `info/update/order/${orderId}/parts`,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not add part',
        retryAction: action,
      },
    });

    if (callback) {
      callback(results);
      yield put(actions.addPartSuccess({ results, addPartsToXml: true }));
    } else {
      yield put(actions.addPartSuccess(results));
    }
  } catch (err) {
    yield put(actions.addPartFailure(err));
  }
}

export function* getLogisticsDates(action) {
  try {
    const orderId = action.payload;
    const results = yield call(callApi, {
      endpoint: `/info/order/${orderId}/logistics`,
      options: {
        method: 'GET',
        errorMessage: `Could not get the logistics dates for the parts from order ${orderId}`,
        retryAction: action,
      },
    });

    yield put(actions.getLogisticsDatesSuccess(results));
  } catch (err) {
    yield put(actions.getLogisticsDatesFailure(err));
  }
}

function* watchSearchPart() {
  yield takeLatest(types.SEARCH_PART_REQUEST, searchPart);
}

function* watchAddPart() {
  yield takeLatest(types.ADD_PART_REQUEST, addPart);
}

function* watchLogisticsDates() {
  yield takeLatest(types.GET_LOGISTICS_DATES_REQUEST, getLogisticsDates);
}

export default [
  fork(watchSearchPart),
  fork(watchAddPart),
  fork(watchLogisticsDates),
];
